import "../Challenges.css"
import React, { useState,useEffect } from "react";
import api from "views/auth/Api";
import "../../myProjects/Myprojects.css"
import Upload from "../../profile/components/Upload";
import Points from "./points";
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FILES_URL } from '../../../../configs/AppConfig';
import { FileUploader } from 'react-drag-drop-files';
import { message } from 'antd';
import ChallangeStudent from "../../tables/components/ChallangeStudent";
import {columnsFeedback} from "../../tables/variables/columnsData";


const fileTypes = ["pdf"];
const modelTypes = ["stl"];

const CreateChallanges = () => {

  const [data , setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [pdf, setPdf] = useState(null);
  const [model, setModel] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [modelLoading, setModelLoading] = useState(false);
  
  const [current , setCurrent] = useState("overview");
  const { id } = useParams();
  const navigate = useNavigate();
  console.log("Challenge ID:", tableData);
        
        
    const successPdf = () => {
      message.success('Your PDF uploaded successfully');
          };
    const successModel = () => {
           message.success('Your STL uploaded successfully');
          };
    const success = () => {
           message.success('Your Submit Done successfully');
          };
     
    const handleChange = async (pdf) => {
        setPdfLoading(true);
          const formData = new FormData();
          formData.append('pdf', pdf);
           await api.post(`${API_BASE_URL}attachment/pdf`,formData, {
                      headers: {
            'Content-Type': 'multipart/form-data',
          }})
              .then(function (response) {
                setPdfLoading(false);
                        successPdf();
                        setPdf(response.data);
                          }).catch(error => {
                            console.log("handlesubmit error for blog get ", error)
                            });
  };

  const handleModel = async (model) => {
        setModelLoading(true);
          const formData = new FormData();
          formData.append('stl', model);
           await api.post(`${API_BASE_URL}attachment/stl`,formData, {
                      headers: {
            'Content-Type': 'multipart/form-data',
          }})
              .then(function (response) {
                setModelLoading(false);
                        successModel();
                        setModel(response.data);
                          }).catch(error => {
                            console.log("handlesubmit error for blog get ", error)
                            });
  };

     useEffect(() => {
     api.get(`${API_BASE_URL}assigned-challenge/${id}`)
      .then((response) => {  
        if (!response.data) {
          navigate(`/auth/not-found/`);
        }
        setData(response.data);
        setTableData(response.data?.submission);
      })
      .catch((error) => {
        console.error('Error fetching card:', error);
      });
  }, [navigate,id]);
  
  const MyComponent=({ htmlContent }) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} className="my-component"/>
  );
}

    const handleSubmit = () => {
      submitForm();
        setPdf(null);
        setModel(null);
    }
      const submitForm = async () => {
      if(pdf || model)  await api.post(`${API_BASE_URL}challange-submission`,{
          presentation: pdf? pdf.id : null,
          model3d: model? model.id : null,
          challangeId: data.id
          })
        .then(function (response) {
                  console.log("handlesubmitffff  ", response.data)
                  setTableData(response.data)
                  success();
        }).catch(error => {
          console.log("handlesubmit error for blog get ", error)
        });       
          }


  return (
    <div>
      <div className="create-header">
        <div className="Challenge-NameInfo">
        <h2>{data.challenge?.challengeTitle}</h2>
        <div className="remaining-points">
          <p>{data.challenge?.subject}</p>
          <p>{data.dueDate?.substring(0, 10)} </p>
          <p>{data.points} points</p>
          {/* <span>2days remaining</span> */}
        </div>
          <div className="headerLinks mt-[10px]">
        <div className="headerLink" onClick={() => setCurrent("overview")}> <span className={current==="overview" ? "active" : "noActive"}>Overview</span>
        </div>
        <div className="headerLink" onClick={() => setCurrent("subFeed")}> <span className={current==="subFeed" ? "active" : "noActive"}>Submission & Feedback</span>
        </div>
         </div>

        {/* <div class="progress-container">
         <div class="progress-bar" ></div>
         </div> */}
          </div>
         {/* <div className="challangeHeaderImg">
         </div> */}
         <Points/>
      </div>
      {current === "overview" ? 
      <div>
      <div className="challangePic" style={{backgroundImage:`url(${FILES_URL}${data.challenge?.coverImg?.url})`}}></div>
      <div className="challangeInstr">
       <div className="pCreate">
        <div className="lRCreate">
        <h4 className="h4Create">Challenge Theme : </h4>
                <MyComponent htmlContent={data.challenge?.requirement?.theme}/>
        <h4 className="h4Create">Mission : </h4>
                <MyComponent htmlContent={data.challenge?.requirement?.mission}/>
          <h4 className="h4Create">Design & Submission Guidelines : </h4>
                <MyComponent htmlContent={data.challenge?.requirement?.designSubmission}/>
          </div>
          <div className="lRCreate">
          <h4 className="h4Create">Judging Criteria : </h4> 
                          <MyComponent htmlContent={data.challenge?.requirement?.judgingCriteria}/>
          <h4 className="h4Create">Terms & Conditions : </h4> 
                          <MyComponent htmlContent={data.challenge?.requirement?.termsConditions}/>
          <h4 className="h4Create">Nutshell : </h4> 
                          <MyComponent htmlContent={data.challenge?.requirement?.nutshell}/>
          </div>
          </div>
      </div>
      <div className="challengeVideo">
      <video width="1000px" height="500" controls className="videoEdit">
  <source src="movie.mp4" type="video/mp4"/>
  <source src="movie.ogg" type="video/ogg"/>
Your browser does not support the video tag.
</video>

      </div>
       <div className="Submission-container">
        <div className="leftDev" >
          <div className="uploadBoxs">
            <div className="devParant">
              {/* <h4 className="uploadh4"> Presentation PDF </h4> */}
              {/* <div className="uploaddev">
              </div> */}
        <div className="uploaderSub">
          <FileUploader handleChange={handleChange} name="file" types={fileTypes}> 
          <Upload  title={pdf ? pdf.name : "Presentation PDF" } file={pdf} type="pdf" loading={pdfLoading}/>
          </FileUploader>
          </div>

            </div>
            <div className="devParant">
          <div className="uploaderSub">
          <FileUploader handleChange={handleModel} name="file" types={modelTypes}>
          <Upload title={model ? model.name : "3D Model" } file={model} type="stl" loading={modelLoading}/>
          </FileUploader>
          </div>
            </div>
          </div>
        </div>

          <div className="rightDev">
          <div className="submitDev">
          <button className="submit" onClick={handleSubmit}>Submit</button>
          </div>

            {/* <div className="teamsTop">
              <h2 className="rightH2">Team Members</h2>
              <div className="teamMembers">
                                {data.map((project,index) =>
            <div className="top4">
                <div className="animation-team"></div>
                <span>{project.userName}</span>
            </div>)}

              </div>
            </div>
            <div className="teamsBottom">
              <h2 className="rightH2">Recent Activity</h2>
              <div className="teamActivity"></div>
            </div> */}
          </div>
          </div>
        </div> : current === "subFeed" ?
      <ChallangeStudent columnsData={columnsFeedback}
                          tableData={tableData}
                          /> : null}
    </div>
  );
};

export default CreateChallanges;
